import { type ExpenseAccount } from "@finway-group/shared/lib/models"
import { Select } from "antd"
import { type SelectProps } from "antd/lib/select"
import React from "react"
import { useTranslation } from "react-i18next"
import { NOT_SET_VALUE } from "~Shared/config/consts"
import { doFilterSelect } from "~Shared/utils/helper.utils"
import { getPopupAnchor } from "~Shared/utils/popup.utils"

interface ExpenseAccountSelectProps extends SelectProps {
    expenseAccounts: Array<ExpenseAccount>
    showNotSetOption?: boolean
}

export const ExpenseAccountSelect = ({ expenseAccounts, showNotSetOption = true, ...selectProps }: ExpenseAccountSelectProps) => {
    const { t } = useTranslation()
    if (expenseAccounts.length === 0) {
        return null
    }
    const placeholder = selectProps.placeholder || t("placeholder:expense_account.select_an_expense_account")

    return (
        <Select {...selectProps} showSearch filterOption={doFilterSelect} dropdownMatchSelectWidth={false} placeholder={placeholder} getPopupContainer={getPopupAnchor()}>
            {showNotSetOption && (
                <Select.Option value={NOT_SET_VALUE} label="">
                    <div className="flex items-center">
                        <span>{t("missing:request.expense_account")}</span>
                    </div>
                </Select.Option>
            )}
            {expenseAccounts.map((expAccount, index) => (
                <Select.Option key={index} value={expAccount._id} label={`${expAccount.accountName} ${expAccount.accountCode}`}>
                    {expAccount.accountCode} - {expAccount.accountName}
                </Select.Option>
            ))}
        </Select>
    )
}
